<script>
	export let name;
	export let icon;
	export let levelcompetence;
	export let agegroup;
	export let description;
	export let weightlimit;
	export let activityname;
</script>
<div class="restaurant_box">
	<div class="vc_column-inner">
		<div class="d-flex mobile-fc">
			<div class="restaurant_menu w-60" style="height: 350px; background-image: url('../images/{icon}');">
				<!-- <img src="/images/{icon}" alt="" /> -->
			</div>
			<div class="w-60">
				<div class="restaurant_right">
					<div class="vc_column-inner ">
						<div class="">
							<div class="vc_separator">
								<h4>
									<span>
										{name}
									</span>
								</h4>
							</div>
							<div class="">
								<div class="">
									{#if activityname}
										<p>
											{activityname}
										</p>
									{/if}
									<p>Recommended Age Group : {agegroup}</p>
										{#if weightlimit}
											<p>Weight Limit:{weightlimit}</p>
										{/if}
									<p>Level of Competence : {levelcompetence}</p>
									<p>
										Description: {description}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</div>


<style>
	.vc_separator  {
		margin-bottom: 35px;
	}
	
	.vc_separator h4 {
		line-height: 1em;
		font-size: 100%;
		margin: 0;
		word-wrap: break-word;
		-webkit-box-flex: 0;
		-webkit-flex: 0 1 auto;
		-ms-flex: 0 1 auto;
		flex: 0 1 auto;
	}

	.restaurant_box {
		margin-bottom: 25px;
		margin-top: 25px;
	}

	.restaurant_right {
		padding-left: 50px;
		padding-top: 4px;
		padding-right: 25px;
	}

	.vc_separator {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	h4 {
		min-width: 20%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.w-60 {
		width: 60%;
	}

	.restaurant_menu {
		border: 1px solid #ccc;
		background-position: center !important;
		background-repeat: no-repeat !important;
		background-size: contain !important;
	}

	.vc_separator h4 {
		background: rgb(15, 36, 83);
		height: 2px;
		display: flex;
		align-items: center;
		padding: 0;
		margin: 0;
		width: 100%;
	}

	.vc_separator span {
		padding: 0 15px;
		background: #fff;
	}

	p {
    	color: #444;
		font-size: 1.125rem;
		line-height: 2rem;
		margin: 0 0 10px;
	}

	@media only screen and (min-width: 320px) and (max-width: 600px) {
		:global(.mobile-fc) {
			flex-flow: column;
		}

		.w-60 {
			width: 100%;
		}

		.restaurant_right {
			padding-left: 20px;
			padding-top: 24px;
			padding-right: 20px;
		}
	}

</style>